import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { ROUTES } from '../../../classes/routes';

const TAB_TO_SEGMENT: Record<string, string> = {
	config: 'config',
	export: 'export-queue',
	inbound: 'inbound',
	shipments: 'shipments',
	inventory: 'inventory',
	logs: 'logs',
	dashboard: 'dashboard',
	open_orders: 'open-orders',
	openorders: 'open-orders',
	capture_auths: 'capture-auths',
	captureauths: 'capture-auths',
	void_auths: 'void-auths',
	voidauths: 'void-auths'
};

function getTpl3plPageTitle(path: string): string {
	const tpl3plRoute = ROUTES.find(r => r.path === '/tpl3pl');
	const pathNorm = (path || '/tpl3pl').replace(/\/$/, '');
	const withSlash = pathNorm.startsWith('/') ? pathNorm : '/' + pathNorm;
	const child = tpl3plRoute?.children?.find((c: any) => c.path === withSlash);
	return child?.title || '3PL Integration';
}

@Component({
	selector: 'app-tpl3pl-layout',
	templateUrl: './tpl3pl-layout.component.html',
	styleUrls: ['./tpl3pl-layout.component.scss']
})
export class Tpl3plLayoutComponent implements OnInit {
	color = 'blue';
	pageTitle = '3PL Integration';
	isDashboard = false;

	constructor(
		private globalSearchService: GlobalSearchService,
		private route: ActivatedRoute,
		private router: Router
	) {
		this.color = this.globalSearchService.getColor();
	}

	private setTitleFromRoute(): void {
		const path = this.router.url.split('?')[0];
		const withLeading = path.startsWith('/') ? path : '/' + path;
		this.pageTitle = getTpl3plPageTitle(withLeading);
		const p = withLeading.replace(/\/$/, '') || '/';
		this.isDashboard = p === '/tpl3pl' || p.endsWith('/tpl3pl/dashboard');
	}

	ngOnInit(): void {
		this.setTitleFromRoute();
		this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => this.setTitleFromRoute());
		this.route.queryParamMap.subscribe(params => {
			const tab = params.get('tab');
			const segment = tab ? TAB_TO_SEGMENT[tab] : null;
			const path = this.router.url.split('?')[0].replace(/\/$/, '');
			if (segment && path === '/tpl3pl') {
				this.router.navigate([segment], { relativeTo: this.route, replaceUrl: true, queryParams: {} });
			}
		});
	}

	back(): void {
		this.router.navigate(['/tpl3pl/dashboard']);
	}
}
